import React from "react";
import PropTypes from "prop-types";

/** Components */
import SubLayout from "../../layouts/components/subLayout/SubLayout";

/** CSS */
import "./Dashboard.scss";


const Dashboard = (WrappedComponent) => {
  
  const ChildComponent = (props) => (
    
    <SubLayout>
      <WrappedComponent {...props} />
    </SubLayout>
  );

  return ChildComponent;
};


Dashboard.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
};

export default Dashboard;
